import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * CommentsForm Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Comments form section title
     */
    @Prop() title!: string;

    /**
     * Comments config
     */
    @Prop() configs!: object;

    /**
     * Submit button color
     */
    @Prop() color!: string;

    /**
     * color of uploader button
     */
    @Prop() uploaderColor!: string;

    /**
     * Url_encode of post
     */
    @Prop() urlEncode!: string;

    /**
     * Id of post
     */
    @Prop() postId!: string;

    /**
     * Type of post
     */
    @Prop() postType!: string;

    /**
     * Form labels list
     */
    @Prop({ type: Object }) labels!: { [k: string]: any };
}
